import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';

/**
 *  Egy mezős kereső az egész iratanyagon.
 *
 *  Iktatószámra, tárgyra, partnerre, hivatkozási számra és a CSATOLT FÁJLOK nevére is
 *  keres – az iratkezelés akkor ér valamit, ha három év múlva is előkerül, amit keresel.
 */
@Component({
  selector: 'app-ikt-kereses',
  templateUrl: './kereses.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktKeresesComponent {
  q = '';
  ugyiratok: any[] = [];
  iratok: any[] = [];
  keresve = false;
  betoltes = false;

  constructor(private ikt: IktatgatoService, private router: Router) {}

  async keres() {
    const sz = this.q.trim();
    if (sz.length < 2) { this.keresve = false; return; }
    this.betoltes = true;
    try {
      const r = await this.ikt.kereses(sz);
      this.ugyiratok = r.ugyiratok || [];
      this.iratok = r.iratok || [];
      this.keresve = true;
    } catch {
      this.ugyiratok = []; this.iratok = []; this.keresve = true;
    } finally {
      this.betoltes = false;
    }
  }

  ugyiratra(u: any) { this.router.navigateByUrl('/iktatgato/ugyirat/' + u.id); }
  iratra(i: any) { this.router.navigateByUrl('/iktatgato/irat/' + i.id); }
}
